import { Component, Input } from '@angular/core';
import { StateService } from '@uirouter/angular';

@Component({
  selector: 'commit-header',
  template: require('./commit-header.directive.html'),
})
export class CommitHeaderComponent {
  @Input() commit: any;

  constructor(private stateService: StateService) {
  }

  goToUserHome(unixName: string) {
    this.stateService.go('home.user.userhome', { unixName: unixName });
  }
}

